// A2F-766: Section 6 body for /configure (edit mode).
//
// Replaces the SectionSaveInstall signup form on the editor surface
// with a Save button. Status pill is rendered by the parent
// SectionCard via statusOverride — this body is just the action.
//
// Save semantics intentionally match the v1 /configure surface:
// button-driven (no autosave), dirty bit tied to state divergence,
// errors are sticky with a manual retry. No reset/discard affordance
// (v1 didn't have one either, scope discipline).

export type SaveStatus = 'idle' | 'dirty' | 'saving' | 'saved' | 'error'

interface SectionSaveEditProps {
  status: SaveStatus
  onSave: () => void
}

export function SectionSaveEdit({ status, onSave }: SectionSaveEditProps) {
  const disabled = status === 'idle' || status === 'saved' || status === 'saving'
  const label =
    status === 'saving'
      ? 'Saving…'
      : status === 'saved'
        ? 'Saved'
        : status === 'error'
          ? 'Retry save'
          : status === 'dirty'
            ? 'Save changes'
            : 'Saved'

  return (
    <div className="space-y-3">
      <p className="text-[12px] text-slate-500 leading-relaxed">
        Saving updates your ribbon profile. Reloads pick up the new
        configuration on the next Word session — no re-sideload needed.
      </p>
      <button
        type="button"
        onClick={onSave}
        disabled={disabled}
        className="w-full rounded-lg bg-brand-orange px-5 py-3.5 text-sm font-semibold text-white hover:bg-brand-orange/90 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {label}
      </button>
    </div>
  )
}
